<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>Grupo de permissões</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <div v-tooltip="!resourceAvailability.features.includes('custom_roles') ? 'Faça upgrade do plano' : null">
              <button
                type="button"
                class="btn btn-primary"
                @click="showCreateModal()"
                :disabled="!resourceAvailability.features.includes('custom_roles')">
                + {{ $t('New group') }}
                </button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort field="name" :value="sort" @input="setSort">{{ $t('Name') }}</th-sort>
                <th>{{ $t('Members') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(item, index) in roles"
                :key="index">
                <td class="text-truncate">
                  <a href="javascript:void(0)" @click="showEditModal(item)" v-if="!item.administrator">{{ item.name }}</a>
                  <span v-if="item.administrator">{{ item.name }}</span>
                </td>
                <td class="text-truncate">{{ item.members_count }}</td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <role-form 
        v-if="modal_select"
        :initRole="modal_select" 
        @hideModal="hideModal()"
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()">
        </role-form>

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import RoleForm from './RoleForm'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Role',
  components: {
    RoleForm,
    ThSort,
    InputKeyword,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name'
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    roles () {
      return this.$store.getters.getRoles
    },
    paginate () {
      return this.$store.getters.getRolesPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectRoles', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Role/Role.vue